import date from './date'
// import share from './share'
import utils from './utils'
import array from './array'
export default {...date, ...utils,...array}
